import ProceduresGroupedList from './ProceduresGroupedList';

export default ProceduresGroupedList;
